import { render, staticRenderFns } from "./OphthalmologyForm.vue?vue&type=template&id=2a583aa0"
import script from "./OphthalmologyForm.vue?vue&type=script&lang=js"
export * from "./OphthalmologyForm.vue?vue&type=script&lang=js"
import style0 from "./OphthalmologyForm.vue?vue&type=style&index=0&id=2a583aa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports